var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service, Inject } from "@bluelibs/core";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { UsersCollection, CompaniesCollection, } from "@bundles/UIAppBundle/collections";
let CompanyEditForm = class CompanyEditForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "name",
                label: t("management.companies.fields.name"),
                name: ["name"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "email",
                label: t("management.companies.fields.email"),
                name: ["email"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "phone",
                label: t("management.companies.fields.phone"),
                name: ["phone"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "address",
                label: t("management.companies.fields.address"),
                name: ["address"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "city",
                label: t("management.companies.fields.city"),
                name: ["city"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "state",
                label: t("management.companies.fields.state"),
                name: ["state"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "zip",
                label: t("management.companies.fields.zip"),
                name: ["zip"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "country",
                label: t("management.companies.fields.country"),
                name: ["country"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "website",
                label: t("management.companies.fields.website"),
                name: ["website"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "allowedUsersIds",
                label: t("management.companies.fields.allowedUsers"),
                name: ["allowedUsersIds"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", required: true, mode: "multiple" }, void 0) }), void 0)),
            },
        ]);
    }
    static getRequestBody() {
        return {
            _id: 1,
            name: 1,
            email: 1,
            phone: 1,
            address: 1,
            city: 1,
            state: 1,
            zip: 1,
            country: 1,
            website: 1,
            allowedUsers: {
                _id: 1,
                fullName: 1,
            },
            allowedUsersIds: 1,
        };
    }
    onSubmit(_id, values) {
        const { t } = this.i18n;
        return this.collection
            .updateOne(_id, { $set: values })
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.companies.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => CompaniesCollection),
    __metadata("design:type", typeof (_a = typeof CompaniesCollection !== "undefined" && CompaniesCollection) === "function" ? _a : Object)
], CompanyEditForm.prototype, "collection", void 0);
CompanyEditForm = __decorate([
    Service({ transient: true })
], CompanyEditForm);
export { CompanyEditForm };
